import { hbs } from 'ember-cli-htmlbars';
const __COLOCATED_TEMPLATE__ = hbs("{{! @glint-nocheck: not typesafe yet }}\n<header\n  class=\"cID--pillar__header {{if @isEditing 'is--active'}} qa--contentPillars_theme\"\n  data-test-id=\"content-pillar-card\"\n>\n  {{#if @isEditing}}\n    <Planner::ContentPillars::Card::Edit\n      @contentPillar={{@contentPillar}}\n      @formError={{this.formError}}\n      @regeneratePillar={{this.regeneratePillar}}\n      @saveContentPillar={{this.saveContentPillar}}\n      @title={{this.contentPillarChangeset.title}}\n    />\n  {{else if this.contentPillarChangeset.title}}\n    <Shared::Ui::Button\n      @additional=\"block\"\n      @class=\"cID--pillar__title qa--content_pillars_editThemeButton\"\n      @variant=\"unstyled\"\n      data-test-id=\"content-pillar-card-edit-button\"\n      type=\"button\"\n      {{on \"click\" this.editContentPillar}}\n    >\n      {{this.contentPillarChangeset.title}}\n      <span class=\"cID--pillar__cta\">{{t \"shared_words.edit\"}}</span>\n    </Shared::Ui::Button>\n  {{/if}}\n</header>", {"contents":"{{! @glint-nocheck: not typesafe yet }}\n<header\n  class=\"cID--pillar__header {{if @isEditing 'is--active'}} qa--contentPillars_theme\"\n  data-test-id=\"content-pillar-card\"\n>\n  {{#if @isEditing}}\n    <Planner::ContentPillars::Card::Edit\n      @contentPillar={{@contentPillar}}\n      @formError={{this.formError}}\n      @regeneratePillar={{this.regeneratePillar}}\n      @saveContentPillar={{this.saveContentPillar}}\n      @title={{this.contentPillarChangeset.title}}\n    />\n  {{else if this.contentPillarChangeset.title}}\n    <Shared::Ui::Button\n      @additional=\"block\"\n      @class=\"cID--pillar__title qa--content_pillars_editThemeButton\"\n      @variant=\"unstyled\"\n      data-test-id=\"content-pillar-card-edit-button\"\n      type=\"button\"\n      {{on \"click\" this.editContentPillar}}\n    >\n      {{this.contentPillarChangeset.title}}\n      <span class=\"cID--pillar__cta\">{{t \"shared_words.edit\"}}</span>\n    </Shared::Ui::Button>\n  {{/if}}\n</header>","moduleName":"later/components/planner/content-pillars/card.hbs","parseOptions":{"srcName":"later/components/planner/content-pillars/card.hbs"}});
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { Changeset } from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import { task } from 'ember-concurrency';

import { SegmentEventTypes } from 'later/utils/constants/segment-events';
import ContentPillarValidations from 'later/validations/content-pillar';

import type { EmberChangeset } from 'ember-changeset';
import type ContentPillarModel from 'later/models/content-pillar';
import type AuthService from 'later/services/auth';
import type ErrorsService from 'later/services/errors';
import type SegmentService from 'later/services/segment';
import type { Maybe } from 'shared/types';
import type { ValidationErr } from 'validated-changeset/dist/types';

interface CardComponentArgs {
  contentPillar: ContentPillarModel;
  displayUsageAlert: () => void;
  isEditing: boolean;
  remainingAICredits: number;
  setEditing: (value: boolean) => void;
}

export default class CardComponent extends Component<CardComponentArgs> {
  @service declare auth: AuthService;
  @service declare errors: ErrorsService;
  @service declare segment: SegmentService;

  contentPillarChangeset: EmberChangeset;

  constructor(owner: unknown, args: CardComponentArgs) {
    super(owner, args);

    this.contentPillarChangeset = Changeset(
      this.args.contentPillar,
      lookupValidator(ContentPillarValidations),
      ContentPillarValidations
    );
  }

  get contentIdeasGenerated(): boolean {
    return Boolean(this.args.contentPillar.contentIdeas.length);
  }

  get formError(): Maybe<ValidationErr> {
    return this.contentPillarChangeset?.errors?.map((error) => error.validation).flat()?.[0];
  }

  @action
  editContentPillar(): void {
    this.args.setEditing(true);
  }

  regeneratePillar = task(async (event: MouseEvent | KeyboardEvent) => {
    event.preventDefault();

    try {
      await this.args.contentPillar.regenerate();
      this.segment.track(SegmentEventTypes.UpdatedContentPillar, {
        ai_generated: true,
        best_describes: this.auth.currentAccount.bestDescribes ?? '',
        content_pillar_id: this.args.contentPillar.id
      });
      this.args.setEditing(false);
    } catch (error) {
      this.errors.log('regeneratePillar Error', error);
    }
  });

  saveContentPillar = task(async (event: MouseEvent | KeyboardEvent) => {
    event.preventDefault();

    if (!this.contentPillarChangeset.isValid) {
      return;
    }

    try {
      await this.contentPillarChangeset.save();
      this.segment.track(SegmentEventTypes.UpdatedContentPillar, {
        ai_generated: false,
        best_describes: this.auth.currentAccount.bestDescribes ?? '',
        content_pillar_id: this.args.contentPillar.id
      });
      this.args.setEditing(false);
    } catch (error) {
      this.errors.log('saveContentPillar Error', error);
    }
  });
}
